// Auto-ported from the age-of-mcp /gallery. Low-poly parts flattened to a
// self-contained model (no shared helpers, no animations).
import * as THREE from "three";
import { defineModel } from "../../lib";

export const quartzVein = defineModel({
  id: "quartz-vein",
  batchId: "future",
  name: "Quartz vein",
  tags: ["scenery","quartz","vein","low-poly","age-of-mcp","future"],
  summary: "White quartz in host rock. A purer feed for glass, a smelting flux, an abrasive and a gem stock.",
  description: "Ported from the age-of-mcp gallery (future library).",
  author: "age-of-mcp",
  footprint: 0.4,
  parts: () => [
      { geometry: new THREE.IcosahedronGeometry(0.26, 0), color: "#74707a", position: [-0.1, 0.2, 0], rotation: [0.1, 0.4, 0.08], scale: [1.1, 1, 1] },
      { geometry: new THREE.IcosahedronGeometry(0.2, 0), color: "#83808a", position: [0.16, 0.16, -0.04], rotation: [0.05, 1.1, -0.1] },
      { geometry: new THREE.ConeGeometry(0.05, 0.3, 5), color: "#e8edf2", position: [0, 0.32, 0.04], rotation: [0.1, 0, 0.15] },
      { geometry: new THREE.ConeGeometry(0.045, 0.24, 5), color: "#cdd6df", position: [0.08, 0.28, 0], rotation: [0.2, 0, -0.3] },
      { geometry: new THREE.ConeGeometry(0.04, 0.2, 5), color: "#e8edf2", position: [-0.08, 0.26, 0.06], rotation: [0.1, 0, 0.4] },
      { geometry: new THREE.OctahedronGeometry(0.05, 0), color: "#cdd6df", position: [0.22, 0.06, 0.14], rotation: [0.3, 0.4, 0.2] },
    ],
  animations: [],
});
